module.exports = __webpack_public_path__ + "static/media/img-106.cfcff41f.png";